import HTTP from '../HTTP';

const URL_BASE = 'commun/Tiers/';

export async function get(idTiers) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: idTiers } });
  return response;
}

export async function PGetAllAnonymeWithLiensInferieursAsync(hash, query) {
  const dataQuery = {
    ...query,
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllAnonymeWithLiensInferieursAsync', {
    query: dataQuery,
    sorting: '',
    skipCount: 0,
    maxResultCount: 999999,
  }, { params: { hash } });
  return response;
}

export async function PGetAllAnonymeAsync(hash, query) {
  const dataQuery = {
    ...query,
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllAnonymeAsync', {
    query: dataQuery,
    sorting: '',
    skipCount: 0,
    maxResultCount: 999999,
  }, { params: { hash } });
  return response;
}
